import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  variant?:
    | 'body1'
    | 'body2'
    | 'button'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'inherit'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2';
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
};

const CorrectionButton = (props: Props) => {
  const { sx, children, onClick, disabled, variant } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (disabled) return;
    !!onClick && onClick();
  };

  return (
    <Button
      sx={{
        width: 76,
        height: 30,
        m: 0,
        p: 0.5,
        pt: 1,
        textAlign: 'center',
        border: `solid 1px #555555`,
        bgcolor: baseColors.white,
        borderRadius: '6px',
        opacity: disabled ? 0.3 : 1,
        ...sx
      }}
      onClick={handleClick}
      disabled={disabled}
    >
      <Typography
        variant={variant ? variant : 'caption'}
        sx={{
          color: '#555555',
          baseLine: 'bottom'
        }}
      >
        {children ? children : '修正する'}
      </Typography>
    </Button>
  );
};

export default CorrectionButton;
